document.addEventListener('DOMContentLoaded', function () 
{
  const headerWrapper = document.querySelector('.section-header .header-wrapper');
  const ann = document.querySelector('.announcement-bar-section');
  if (!headerWrapper) return;

  // Measure and expose heights (CSS uses these for the constant banner offset)
  let hh = 0, ah = 0;
  const setVars = () => {
    hh = headerWrapper.offsetHeight || 0;
    ah = ann ? ann.offsetHeight || 0 : 0;
    document.documentElement.style.setProperty('--header-height', hh + 'px');
    document.documentElement.style.setProperty('--ann-height', ah + 'px');
  };

  const TOL = 2; // px tolerance to avoid jitter
  const updateState = () => {
    const y = window.scrollY || window.pageYOffset || 0;
    const threshold = hh;            // flip after you've scrolled the MENU height
    // If you want to include the announcement bar as well, use: const threshold = hh + ah;
    const atTop = y < (threshold - TOL);
    document.body.classList.toggle('over-hero', atTop);
  };

  // rAF-throttled scroll
  let ticking = false;
  const onScroll = () => {
    if (!ticking) {
      requestAnimationFrame(() => { updateState(); ticking = false; });
      ticking = true;
    }
  };

  const recalc = () => { setVars(); updateState(); };

  recalc();                   // initial
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', recalc);
  window.addEventListener('orientationchange', recalc);
  window.addEventListener('load', recalc);

  // If promo/announcement content changes after load, re-measure
  if (ann) {
    const mo = new MutationObserver(recalc);
    mo.observe(ann, { childList: true, subtree: true, characterData: true });
  }
});
